<template>
  <ul :class="['menu-list', { 'submenu-list': isSubmenuList }]">
    <aside-menu-item
      v-for="(item, index) in menu"
      :key="index"
      :item="item"
      @menu-click="$emit('menu-click', $event)"
    />
  </ul>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AsideMenuList',
  components: {
    AsideMenuItem: () => import('@/components/AsideMenuItem.vue')
  },
  props: {
    menu: {
      type: Array,
      required: true
    },
    isSubmenuList: {
      type: Boolean,
      default: false
    }
  },
  emits: ['menu-click']
})
</script>

<style scoped>
.menu-list {
  padding: 0.5rem 0;
}

.submenu-list {
  margin-left: 0;
  padding-left: 0;
  background-color: var(--color-secundario, #050505);
  border-left: none;
}

.submenu-list :deep(li a) {
  padding-left: 2.5rem;
  font-size: 0.9rem;
}

.submenu-list :deep(li a.is-active) {
  background-color: var(--color-secundario, #111);
  border-left-color: #fff;
}
</style>
